import axios from '../../../plugins/axios'

const loginWithGoogle = (params) => axios.post('/api/v1/auth/google', params);
const validate = (params) => axios.post('/api/v1/auth/verify', params);

export default {
  loginWithGoogle,
  validate
}
